import { BaseRequest, IBaseRequest } from '../../BaseRequest';

export interface IListFolderOrganizationRequest extends IBaseRequest {
    countOnly?: string;
    offset?:    string;
    limit?:     string;
    contactId?: string;
}

export class ListFolderOrganizationRequest extends BaseRequest implements IListFolderOrganizationRequest {
    public countOnly?: string;
    public offset?:    string;
    public limit?:     string;
    public contactId?: string;

    constructor(server: string, session: string, otherOptions: any) {
        super(server, session);
        this.countOnly = otherOptions.countOnly;
        this.offset = otherOptions.offset;
        this.limit = otherOptions.limit;
        this.contactId = otherOptions.contactId;
    }

    public toXml(): string {
        var parameters: string = super.toXml();

        parameters += this.makeNode(this.countOnly, 'countOnly');
        parameters += this.makeNode(this.offset, 'offset');
        parameters += this.makeNode(this.limit, 'limit');
        parameters += this.makeNode(this.contactId, 'contactId');
        
        return super.wrapperXml('ListFolderOrganization', parameters);
    }
}
